<template>
  <tr>
    <td
      class="boss-center boss-table-4-link-cell"
      data-test="date"
    >
      {{ applicationDate }}
      <div data-test="time">
        {{ applicationTime }}
      </div>
    </td>
    <td class="boss-center">
      <span data-test="user-id">ID:{{ entry.user.id }}</span>
      <span v-if="entry.user.isDuplicatedEntries">
        <br>
        <span
          v-tooltip="{ content: '別職種での応募や、過去1年以内の掲載時に応募があった場合に表示されます。'}"
          class="boss-status-label"
          data-test="duplicate"
        >重複応募
        </span>
      </span>
      <div data-test="member-name">
        {{ memberName }}
      </div>
      <div data-test="member-summary">
        {{ memberSummary }}
      </div>
    </td>
    <td
      class="is-boss-only-pc"
      data-test="job-id"
    >
      求人ID:{{ entry.job.id }}
      <div data-test="job-name">
        {{ jobName }}
      </div>
    </td>
    <td class="boss-center">
      <div class="boss-layout boss-layout-vertical">
        <div>
          <div class="boss-layout boss-layout-gap-small">
            <div
              v-if="entry.approachingStatus.scout.isSend"
            >
              <span
                v-tooltip="{ content:entry.approachingStatus.scout.isEffective ? '' : expiredMessage }"
                class="pega-scout-label"
                :disabled="!entry.approachingStatus.scout.isEffective"
                data-test="scout-label"
              >スカウト</span>
            </div>
            <div
              v-if="entry.approachingStatus.offerDm.isSend"
            >
              <img
                v-tooltip="{ content:entry.approachingStatus.offerDm.isEffective ? 'オファーDM' : expiredMessage }"
                :class="{ 'boss-icon-end': !entry.approachingStatus.offerDm.isEffective }"
                src="@/assets/images/icon-offer-dm.svg"
                data-test="dm-icon"
              >
            </div>
          </div>
        </div>
        <div>
          <div class="boss-layout boss-layout-vertical boss-layout-no-gap">
            <div
              v-for="sendingFavor in entry.approachingStatus.specialFavors"
              :key="sendingFavor.id"
            >
              <span
                v-tooltip="{ content: getSpecialFavorTooltip(sendingFavor)}"
                :data-test="'special-favor-' + sendingFavor.id"
                :class="{ 'boss-bonus-end': !sendingFavor.isEffective }"
                class="boss-bonus-check-text boss-bonus-check-text-gap-small boss-check-true"
              >{{ sendingFavor.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </td>
    <message-icon-information
      :message="entry.message"
      :is-entry-message-reservation-reserved="entry.isEntryMessageReservationReserved"
    />
    <td class="boss-center is-boss-only-pc">
      <span data-test="phase">{{ convertLabelByIdFromMaster(entry.currentSelection.phaseId, phases) }}</span>
    </td>
    <td class="boss-center is-boss-only-pc">
      <span data-test="status">{{ convertLabelByIdFromMaster(entry.currentSelection.statusId, allStatuses) }}</span>
    </td>
    <td class="pega-remarks-label is-boss-only-pc">
      <span data-test="remarks">{{ entry.remarks }}</span>
    </td>
  </tr>
</template>

<script>
import dayjs from 'dayjs'
import _ from 'lodash'
import * as parse from '@/lib/parse'
import { mapGetters } from 'vuex'
import MessageIconInformation from '@/components/atoms/MessageIconInformation'

export default {
  components: {
    MessageIconInformation
  },
  props: {
    entry: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('settings', [
      'phases',
      'allStatuses'
    ]),
    ...mapGetters({
      specialFavorBy: 'specialFavorBy'
    }),
    expiredMessage: () => '期限切れのため、薄色で表示しています。',
    applicationDate () {
      return dayjs(_.get(this.entry, 'entryDate')).format('YY/MM/DD')
    },
    applicationTime () {
      return dayjs(_.get(this.entry, 'entryDate')).format('HH:mm')
    },
    memberSummary () {
      const summaries = [_.get(this.entry, 'user.prefecture.name'), this.parseAge(_.get(this.entry, 'user.birthday')) + '歳', _.get(this.entry, 'user.gender.name')]
      return _(summaries).compact().join(' ')
    },
    memberName () {
      return this.entry.user.lastName + this.entry.user.firstName
    },
    receivedMessageCount () {
      return _.get(this.entry.message, 'receivedCount', 0)
    },
    isMessageRead () {
      return _.get(this.entry.message, 'isRead', false)
    },
    isMessageReplied () {
      return _.get(this.entry.message, 'isReplied', false)
    },
    evaluationName () {
      return _.get(this.entry.currentSelection.evaluation, 'name', '')
    },
    jobName () {
      if (this.entry.job.name.length > 20) {
        return this.entry.job.name.match(/^.{0,20}/) + '...'
      } else {
        return this.entry.job.name
      }
    }
  },
  methods: {
    parseAge (birthdateString) {
      return parse.age(birthdateString)
    },
    convertLabelByIdFromMaster (id, master) {
      return _.get(_.find(master, { id: id }), 'name', '−')
    },
    getSpecialFavorTooltip (specialFavor) {
      return specialFavor.isEffective ? this.specialFavorBy(specialFavor.id).description : this.expiredMessage
    }
  }
}
</script>
